import * as React from 'react';

import { FormattedMessage, InjectedIntlProps  } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';

import { registerStore } from 'actions/account';
import { InvoiceActionCreators } from 'actions/invoice';
import { AccountStoreForm } from 'components/AccountStoreForm';
import { LayoutHeader } from 'components/Layout';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'constants/analytics';
import { ROUTE_WALLET_DASHBOARD } from 'constants/app';
import { sendEvent } from 'helper/analytics';
import { injectIntl } from 'helper/redux';
import { AccountStoreForm as AccountStoreFormModel } from 'models/account';

import './AccountStoreRegister.scss';

interface DispatchProps {
  registerStore: typeof registerStore;
  setHasNotPassedOnboarding: typeof InvoiceActionCreators.setHasNotPassedOnboarding.create;
}

type OwnProps = InjectedIntlProps & RouteComponentProps<{}>;

type AccountStoreRegisterProps = DispatchProps & OwnProps;

@injectIntl()
class AccountStoreRegisterContainer extends React.Component<AccountStoreRegisterProps, {}> {
  constructor(props: AccountStoreRegisterProps) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
  }

  render() {
    const { intl } = this.props;
    return (
      <div className="o-container o-container--fluid o-container--fluid-vertical">
        <LayoutHeader actionIcon="ic-close" actionHandler={this.onCloseButtonClick}>
          <h1 className="o-layout-header-title"><FormattedMessage id="account.store.form.title"/></h1>
        </LayoutHeader>
        <p className="o-footnote-1">
          <FormattedMessage id="account.store.register.message" />
        </p>
        <AccountStoreForm intl={intl} onSubmit={this.onSubmit}/>
      </div>
    );
  }

  private onSubmit(formValue: AccountStoreFormModel) {
    sendEvent({
      action: AnalyticsEventAction.ACCOUNT_REGISTER_STORE,
      category: AnalyticsEventCategory.ACCOUNT_REGISTER_STORE
    });

    this.props.registerStore(formValue);
  }

  private onCloseButtonClick() {
    const { history } = this.props;
    this.props.setHasNotPassedOnboarding();

    history.push(ROUTE_WALLET_DASHBOARD);
  }
}

export const AccountStoreRegister = connect<{}, DispatchProps, OwnProps>(
  null, {
    registerStore,
    setHasNotPassedOnboarding: InvoiceActionCreators.setHasNotPassedOnboarding.create
  }
)(AccountStoreRegisterContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Account/Store/AccountStoreRegister/AccountStoreRegister.tsx